import { InputsHeader } from '../InputsHeader';
import { NumericInput } from '../form-controls';
import { Grid } from '../layout';

export function Equipment() {
  return (
    <>
      <InputsHeader title="Equipment" subtitle="Gallon Distribution / Acre" />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <NumericInput
          label="Enter Min"
          name="starterFertilizer.minRate"
          required
          min={0}
          max={30}
        />
        <NumericInput
          label="Enter Max"
          name="starterFertilizer.maxRate"
          required
          min={0}
          max={30}
        />
      </Grid>
    </>
  );
}
